import React from 'react'
import { RouteComponentProps } from 'react-router-dom'

import FEATURES from '../../constants/features'
import usePermission from '../../hooks/usePermission'
import useFeatureDisabled from '../../hooks/useFeatureDisabled'
import StandardError from '../../components/StandardError'
import CustomersList from './CustomersList'
import AssetsList from './AssetsList'

const AssetsPage: React.FC<RouteComponentProps<{ customerId?: string }>> = ({ match }) => {
  let { customerId } = match.params
  const isFeatureDisabled = useFeatureDisabled()
  const permissions = usePermission()

  if (isFeatureDisabled(FEATURES.CUSTOMERS, ['R'])) {
    return permissions.result?.gcmid ? (
      <AssetsList customerId={permissions.result.gcmid} isInternal={false} />
    ) : (
      <StandardError />
    )
  }

  const customerSelected = !!customerId
  return customerSelected ? (
    <AssetsList customerId={customerId!} isInternal={customerSelected} />
  ) : (
    <CustomersList />
  )
}

export default AssetsPage
